<template>
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item style="cursor: pointer;" @click="goMore('/finance/index','首页')">首页</a-breadcrumb-item>
      <a-breadcrumb-item>金融产品</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <div class="serch_border"  v-if="options">
    <div class="serchform">
      所属银行：
      <a-tag :class="{'tag-active':''==guarantees}" @click="postSerchData({'guarantee':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.id==guarantees}" @click="postSerchData({'guarantee':item.id})" v-for="(item,key) in visibleData" :key="key">{{item.name}}</a-tag>
    </div>
    <div v-if="showMoreButton" class="button-align-right-bottom" @click="toggleDataVisibility">{{ showMoreText }}</div>
  </div>
  <!-- <div class="serch_border" v-if="options">
    <div class="serchform">
      贷款期限：
      <a-tag :class="{'tag-active':''==loanDeadlines}"  @click="postSerchData({'loanDeadline':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==loanDeadlines}"  @click="postSerchData({'loanDeadline':item.dictValue})" v-for="(item,key) in options.loanDeadline" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div>
  <div class="serch_border" v-if="options">
    <div class="serchform">
      还款方式：
      <a-tag :class="{'tag-active':''==paymentTypes}"  @click="postSerchData({'paymentType':''})">不限</a-tag>
      <a-tag :class="{'tag-active':item.dictValue==paymentTypes}"  @click="postSerchData({'paymentType':item.dictValue})" v-for="(item,key) in options.paymentType" :key="key">{{item.dictLabel}}</a-tag>
    </div>
  </div> -->
  <div class="cont_body">
    <div v-for="(item,key) in dataSource" :key="key" class="list_cont" @click="goMore('/finance/product/page','金融产品',item.id)">
      <div class="list_img">
        <img v-if="item.img" :src="getImg(item.img)" alt="">
        <img v-else src="@/assets/img/defaultPhoto.png" alt="">
      </div>
      <div class="list_cont_body">
        <h4>{{item.productName}}<span v-if="item.remark">· </span>{{item.remark}} </h4>
        <p>所属银行：<span>
          <!-- <dict-render :dict-obj="dictObjs['guarantee']"
          :text="item.guarantyType"></dict-render> -->
          {{item.institutionsName}}
        </span></p>
        <P>产品介绍：{{item.details}}</P>
      </div>
      <!-- <div class="list_cont_pay">
        <p>贷款额度：<span>{{item.maxLoanLines}}</span>万元</p>
        <p>贷款利率：<span>{{item.rate}}</span>%</p>

      </div> -->
      <div class="list_botton">
        <a-button style="margin-top: 18px;" >查看详情</a-button>
      </div>
    </div>
  </div>
  <!--分页-->
  <div class="pagination">
    <a-pagination v-model="current" :total="total" :page-size="pageSize" showQuickJumper @change="onChange" />
  </div>
</template>
<script>
import { dictMixin, listMixin } from "@/mixins";
import {financeProductWeb,financeInstitutionWeb} from "@/api/finance";
import {common_controller} from "@/api/commonService";
import {file_service} from "@/api/adminService";
// import DictRender from "@/components/other/DictRender";
export default {
  name: 'investor',
//   components: { DictRender },
  mixins: [dictMixin, listMixin],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
        visibleCount: 6,
        showMoreButton: true,
        showMoreText: '显示更多',
      role: null,
      guarantees:'',
      options:null,
      // loanDeadlines:'',
      // paymentTypes:'',
      dictNames: 'LOANTYPE,guarantee',
      listUrl: financeProductWeb.pageList,
      queryParamFixed: {
        institutionsId: this.guarantees
            //   guarantyType: this.guarantees,
              // loanDeadline: this.loanDeadlines,
              // paymentType: this.paymentTypes
       },
    institutions: [],
      current: 1,
      pageSize: 10,
    }
  },
  computed: {
    visibleData() {
      return this.institutions.slice(0, this.visibleCount);
    },
  },
  created(){
    this.getAction({
               url: financeInstitutionWeb.list,
                }).then(res => {
                    this.institutions = res;
                })
  },
  mounted() {
      this.getDict();
        this.role = this.$ls.get('roleCode').replace("[","").replace("]","").replace("\"","").replace("\"","").replace("\"","").replace("\"","").split(',')
        this.role.map( item => {
          if(item=='company'){
          this.role = item
          }
        })
  },
	methods: {
        toggleDataVisibility() {
      if (this.visibleCount < this.institutions.length) {
        this.visibleCount = this.institutions.length;
        this.showMoreText = '收起';
      } else {
        this.visibleCount = 5; // 或者你想要的初始显示数量
        this.showMoreText = '显示更多';
      }
    },
    postSerchData(val){
        if(val.guarantee||val.guarantee==''){
          this.queryParamFixed.institutionsId = val.guarantee
          this.guarantees = val.guarantee
        }
        // if(val.loanDeadline||val.loanDeadline==''){
        //   this.queryParamFixed.loanDeadline = val.loanDeadline
        //   this.loanDeadlines = val.loanDeadline
        // }
        // if(val.paymentType||val.paymentType==''){
        //   this.queryParamFixed.paymentType = val.paymentType
        //   this.paymentTypes = val.paymentType
        // }
      this.loadData()

    },
    getDict(){
        this.getAction({
            url:common_controller.getDictDataByGroupNumber,
            params: {
                groupNumbers: "guarantee,loanDeadline,paymentType"
            }
        }).then(res=>{
            this.options = res
        })
    },
    getImg(imgUrl) {
        return file_service.imagesWeb(imgUrl)
    },
		goMore(url,key,id) {
			this.$router.push({path: url, query: {type: key,queryData: id}})
		},
		backhome() {
      this.goMore('/finance/index')
      // location.reload()
		}
	}
}
</script>
<style scoped lang="less">
@import "../../../css/components.less";
.list_cont{
  color:#b3b2b2;
  width:100%;
  margin-bottom: 16px;
  display: flex;
  &:hover {
    :deep(.ant-btn){
      color:#fff;
      border:1px solid #1890ff;
      background: #1890ff;
    }
  }
  .list_img{
    width: 80px;
    height: 80px;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 30px 20px 20px;
    display: flex;
    align-items: center;
    img{
      width: 100%;
    }
  }
  .list_cont_body{
    flex: 5;
    margin-right:20px;
    h4{
      margin-bottom: 20px;
    }
    p{
      word-break: break-all;
      overflow:hidden;
      text-overflow:ellipsis;
      display:-webkit-box;
      -webkit-box-orient:vertical;
      -webkit-line-clamp:1;
    }
  }
  .list_cont_pay{
    flex: 3;
    padding-left: 40px;
    p{
      line-height: 35px;
      span{
        color:red
      }
    }
  }
  .list_botton{
    flex: 1;
  }
}

:deep(.ant-btn){
	border-radius: 0;
}

.serch_border {
  position: relative; // 设置容器为相对定位

  .button-align-right-bottom {
    // float: right;
    cursor: pointer;
	margin-top: -21px;
	font-size: 14px;
	color: #999;
    position: absolute; // 绝对定位按钮
    right: 0; // 将按钮定位到容器的最右边
    bottom: 0; // 调整底部对齐
  }
}
</style>
